import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from "react-router-dom";
import App from './App';
import Loader from './Components/Loader/Loader';
import { LanguageProvider } from './LanguageContext';
import i18n from './i18n'; // Import the i18n configuration
import './index.css';

ReactDOM.render(   
    <React.StrictMode>
        <Suspense fallback={<Loader />}>
            <I18nextProvider i18n={i18n}>
                <LanguageProvider>
                    <BrowserRouter>
                        <App />
                    </BrowserRouter>
                </LanguageProvider>
            </I18nextProvider>
        </Suspense>
    </React.StrictMode>,
    document.getElementById("root")
);